import { useEffect } from "react";
import SEO from "./SEO";

const Return = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
      <div className="max-w-4xl mx-auto px-4 py-10 text-gray-800 shadow-2xl m-10">
        <SEO
  title="Return & Shipping Policy | Pufframa – Fast, Hassle-Free Service"
  description="Learn about Pufframa’s return process and fast, free shipping on nicotine product orders. Discover how to initiate returns and shipping details for U.S. customers."
  url="https://pufframa.com/return-policy"
  keywords="return policy, nicotine returns, pufframa shipping, fast delivery nicotine, hassle-free return"
  structuredData={{
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Return and Shipping Policy",
    description:
      "Return and shipping policy information for Pufframa. Learn how to return nicotine products and how we handle fast, free domestic shipping.",
    url: "https://pufframa.com/return-policy"
  }}
/>

      <h1 className="text-3xl font-bold mb-6">Return & Shipping Policy</h1>

      {/* Return Policy Section */}
      <section className="mb-10">
        <h2 className="text-xl font-semibold mb-2">Return Policy</h2>
        <p className="mb-4">
          If you are not satisfied with the quality of our products,
          <span className="font-medium"> Pufframa.com</span> will cover all return shipping costs.
        </p>

        <p className="mb-4">
          You may return most new, unopened items within <strong>one week</strong> of delivery for a full refund. We’ll also cover return shipping if the return is due to an error on our part.
        </p>

        <p className="mb-4">
          Refunds are typically processed within <strong>4 weeks</strong> of giving your package to the return shipper. In most cases, it's much faster. Here's how the timeline breaks down:
        </p>

        <ul className="list-disc list-inside ml-4 mb-4">
          <li>5–10 business days: Transit time for your return to reach us</li>
          <li>3–5 business days: Time to process the return once received</li>
          <li>5–10 business days: Bank processing time to issue the refund</li>
        </ul>

        <p className="mb-4">
          To initiate a return, please contact us by phone or through our{" "}
          <a href="/contact" className="text-blue-600 underline">Contact Us</a> page. Include your order number in the message, and we will email you detailed return instructions.
        </p>
      </section>

      {/* Shipping Policy Section */}
      <section>
        <h2 className="text-xl font-semibold mb-2">Shipping</h2>
        <p className="mb-4">
          At <strong>Pufframa.com</strong>, customers enjoy <span className="text-green-600 font-medium">FAST & FREE Shipping</span> with no minimum order requirement.
        </p>

        <p className="mb-4">
          We ship to virtually any address within the United States. However, please note that legal restrictions on certain products may prevent shipping to specific domestic or international destinations.
        </p>

        <p className="mb-4">
          When placing your order, shipping and delivery dates will be estimated based on the availability of items and selected shipping method. Estimated delivery times will be shown on the shipping quotes page during checkout.
        </p>
      </section>
    </div>
  );
};

export default Return;
